module.exports = __webpack_public_path__ + "static/media/b17.d9a9768d.svg";